import React, { useContext, useEffect, useState, useRef } from 'react';
import axios from "axios";
import { Link, useQueryParams } from 'raviger';
import { Button, Card, Col, Collapse, Form, FormControl, InputGroup, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckSquare,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faChevronDoubleDown, faChevronDoubleUp,
  faSquareExclamation,
  faSquareX,
  faUserDoctorMessage} from '@fortawesome/pro-solid-svg-icons';
import Select from 'react-select';
import Moment from 'react-moment';
import moment from 'moment';
import { DateRangePicker } from '../components/Form';
import { useMark } from '../hooks';
import Header from '../components/Header';
import { ITEMS_PER_PAGE } from '../constants';
import { SystemErrorContext } from '../components/SystemError';
import { AuthContext } from "../accounts/AccountsReducer";
import TreatmentCard from "./components/TreatmentCard";
import DiagnosticCard from './components/DiagnosticCard';
import ProcedureCard from './components/ProcedureCard';
function VetRequestSearch({ incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  // Identify any query param data.
  const [queryParams] = useQueryParams();
  const {
    search = '',
    tab = 'vet_requests',
  } = queryParams;

  const priorityText = {urgent:'Urgent (Red)', when_available:'When Available (Yellow)'};
  const labelLookup = {vet_requests:'Veterinary Requests', treatments:'Treatments', diagnostics:'Diagnostics', procedures:'Procedures'};

  const priorityChoices = [
    { value: 'urgent', label: 'Urgent (Red)' },
    { value: 'when_available', label: 'When Available (Yellow)' },
  ];

  const statusChoices = [
    { value: 'Open', label: 'Open' },
    { value: 'Closed', label: 'Closed' },
    { value: 'Canceled', label: 'Canceled' },
  ];

  const treatmentStatusChoices = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Completed', label: 'Completed' },
  ];

  const orderStatusChoices = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
  ];

  const tooltipDict = {
    'vet_requests': 'id, animal id, animal name, concern, and complaint name',
    'treatments': 'id, treatment name, animal name, assignee first name, and assignee last name',
    'diagnostics': 'id, diagnostic name, and animal name',
    'procedures': 'id, procedure name, animal name, performer first name, and performer last name'
  }

  const [data, setData] = useState({vet_requests:[], treatments:[], diagnostics:[], procedures:[], isFetching:false});
  const [shelters, setShelters] = useState({options:[], isFetching:false});
  const [speciesChoices, setSpeciesChoices] = useState([]);
  const [treatmentChoices, setTreatmentChoices] = useState([]);
  const [diagnosticChoices, setDiagnosticChoices] = useState([]);
  const [procedureChoices, setProcedureChoices] = useState([]);
  const [assignees, setAssignees] = useState([]);
  const [searchTerm, setSearchTerm] = useState(search);
  const [showFilters, setShowFilters] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [treatmentIsDisabled, setTreatmentIsDisabled] = useState(true);
  const [diagnosticIsDisabled, setDiagnosticIsDisabled] = useState(true);
  const [procedureIsDisabled, setProcedureIsDisabled] = useState(true);
  const [vetObject, setVetObject] = useState(tab);
  const tempSearchTerm = useRef(null);
  const treatmentRef = useRef(null);
  const diagnosticRef = useRef(null);
  const procedureRef = useRef(null);
  const speciesRef = useRef(null);
  const treatmentSpeciesRef = useRef(null);
  const diagnosticSpeciesRef = useRef(null);
  const procedureSpeciesRef = useRef(null);
  const statusRef = useRef(null);
  const treatmentStatusRef = useRef(null);
  const diagnosticStatusRef = useRef(null);
  const procedureStatusRef = useRef(null);
  const administratorRef = useRef(null);
  const priorityRef = useRef(null);
  const openerRef = useRef(null);
  const performerRef = useRef(null);
  const openStartRef = useRef(null);
  const openEndRef = useRef(null);
  const scheduledStartRef = useRef(null);
  const scheduledEndRef = useRef(null);
  const administeredStartRef = useRef(null);
  const administeredEndRef = useRef(null);
  const diagnosticOrderedStartRef = useRef(null);
  const diagnosticOrderedEndRef = useRef(null);
  const diagnosticCompleteStartRef = useRef(null);
  const diagnosticCompleteEndRef = useRef(null);
  const procedureOrderedStartRef = useRef(null);
  const procedureOrderedEndRef = useRef(null);
  const procedureCompleteStartRef = useRef(null);
  const procedureCompleteEndRef = useRef(null);
  const notAdministeredRef = useRef(null);
  const shelterRef = useRef(null);
  const treatmentShelterRef = useRef(null);
  const diagnosticShelterRef = useRef(null);
  const procedureShelterRef = useRef(null);
  const [vetRequests, setVetRequests] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [diagnostics, setDiagnostics] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [options, setOptions] = useState({species: '', status:null, priority:null, open:null, assignee:null, shelter: ''});
  const [treatmentOptions, setTreatmentOptions] = useState({species: '', status:null, treatment:'', scheduled:null, administered:null, assignee:null, shelter: '', not_administered:null});
  const [diagnosticOptions, setDiagnosticOptions] = useState({species: '', status:null, diagnostic:'', ordered:null, complete:null, shelter: ''});
  const [procedureOptions, setProcedureOptions] = useState({species: '', status:null, procedure:'', ordered:null, complete:null, performer:null, shelter: ''});
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const { markInstances } = useMark();
  const [tooltip, setTooltip] = useState(tooltipDict['vet_requests']);

  // Update searchTerm when field input changes.
  const handleChange = event => {
    tempSearchTerm.current.value = event.target.value;
  };

  // Use searchTerm to filter vet_requests.
  const handleSubmit = async event => {
    event.preventDefault();
    setSearchTerm(tempSearchTerm.current.value);
    setPage(1);
  };

  const handleShowFilters = () => {
    setShowFilters(!showFilters);
  };

  // Parses the Date Range object
  function parseDateRange(dateRange) {
    if (dateRange.length > 1) {
      dateRange = dateRange.toString().split(',');
      setStartDate(moment(dateRange[0]).format('YYYY-MM-DD'))
      setEndDate(moment(dateRange[1]).format('YYYY-MM-DD'));
    }
  }

  function setFocus(pageNum) {
    if (pageNum !== page) {
      tempSearchTerm.current.focus();
    }
  };

  function handleApplyFilters(test) {
    if (vetObject === 'vet_requests') {
      const filtered_requests = test.filter(vet_request => options.species ? vet_request.animal_object.species_string.toLowerCase() === options.species.toLowerCase() : vet_request)
        .filter(vet_request => options.status ? vet_request.status === options.status : vet_request)
        .filter(vet_request => options.priority ? vet_request.priority === options.priority : vet_request)
        .filter(vet_request => options.open_start ? (moment(options.open_start).format('YYYY-MM-DD HH:mm') <= moment(vet_request.open).format('YYYY-MM-DD')) : vet_request)
        .filter(vet_request => options.open_end ? (moment(options.open_end).format('YYYY-MM-DD HH:mm') >= moment(vet_request.open).format('YYYY-MM-DD')) : vet_request)
        .filter(vet_request => options.opener ? vet_request.requested_by_object.id === options.opener : vet_request)
        .filter(vet_request => options.shelter && options.shelter !== 'Field' ? vet_request.animal_object.shelter === options.shelter : vet_request)
        .filter(vet_request => options.shelter === 'Field' ? vet_request.animal_object.shelter === null : vet_request);
      setVetRequests(filtered_requests);
      setNumPages(Math.ceil(filtered_requests.length / ITEMS_PER_PAGE));
    }
    else if (vetObject === 'treatments') {
      const filtered_treatments = test.filter(treatment => treatmentOptions.species ? treatment.animal_object.species_string.toLowerCase() === treatmentOptions.species.toLowerCase() : treatment)
        .filter(treatment => treatmentOptions.status ? treatment.status === treatmentOptions.status : treatment)
        .filter(treatment => treatmentOptions.not_administered === true || treatmentOptions.not_administered === false ? treatment.not_administered === treatmentOptions.not_administered : treatment)
        .filter(treatment => treatmentOptions.treatment ? treatment.treatment_object.description === treatmentOptions.treatment : treatment)
        .filter(treatment => treatmentOptions.scheduled_start ? (treatmentOptions.scheduled_start <= moment(treatment.suggested_admin_time).format('YYYY-MM-DD')) : treatment)
        .filter(treatment => treatmentOptions.scheduled_end ? (treatmentOptions.scheduled_end >= moment(treatment.suggested_admin_time).format('YYYY-MM-DD')) : treatment)
        .filter(treatment => treatmentOptions.administered_start ? (treatmentOptions.administered_start <= moment(treatment.actual_admin_time).format('YYYY-MM-DD')) : treatment)
        .filter(treatment => treatmentOptions.administered_end ? (treatmentOptions.administered_end >= moment(treatment.actual_admin_time).format('YYYY-MM-DD')) : treatment)
        .filter(treatment => treatmentOptions.assignee ? treatment.assignee_object && treatment.assignee_object.id === treatmentOptions.assignee : treatment)
        .filter(treatment => treatmentOptions.shelter && treatmentOptions.shelter !== 'Field' ? treatment.animal_object.shelter === treatmentOptions.shelter : treatment)
        .filter(treatment => treatmentOptions.shelter === 'Field' ? treatment.animal_object.shelter === null : treatment)
      setTreatments(filtered_treatments);
      setNumPages(Math.ceil(filtered_treatments.length / ITEMS_PER_PAGE));
    }
    else if (vetObject === 'diagnostics') {
      const filtered_diagnostics = test.filter(diagnostic => diagnosticOptions.species ? diagnostic.animal_object.species_string.toLowerCase() === diagnosticOptions.species.toLowerCase() : diagnostic)
        .filter(diagnostic => diagnosticOptions.status ? diagnostic.status === diagnosticOptions.status : diagnostic)
        .filter(diagnostic => diagnosticOptions.diagnostic ? diagnostic.name === diagnosticOptions.diagnostic : diagnostic)
        .filter(diagnostic => diagnosticOptions.ordered_start ? (diagnosticOptions.ordered_start <= moment(diagnostic.open).format('YYYY-MM-DD')) : diagnostic)
        .filter(diagnostic => diagnosticOptions.ordered_end ? (diagnosticOptions.ordered_end >= moment(diagnostic.open).format('YYYY-MM-DD')) : diagnostic)
        .filter(diagnostic => diagnosticOptions.complete_start ? (diagnosticOptions.complete_start <= moment(diagnostic.complete).format('YYYY-MM-DD')) : diagnostic)
        .filter(diagnostic => diagnosticOptions.complete_end ? (diagnosticOptions.complete_end >= moment(diagnostic.complete).format('YYYY-MM-DD')) : diagnostic)
        .filter(diagnostic => diagnosticOptions.shelter && diagnosticOptions.shelter !== 'Field' ? diagnostic.animal_object.shelter === diagnosticOptions.shelter : diagnostic)
        .filter(diagnostic => diagnosticOptions.shelter === 'Field' ? diagnostic.animal_object.shelter === null : diagnostic)
      setDiagnostics(filtered_diagnostics);
      setNumPages(Math.ceil(filtered_diagnostics.length / ITEMS_PER_PAGE));
    }
    else if (vetObject === 'procedures') {
      const filtered_procedures = test.filter(procedure => procedureOptions.species ? procedure.animal_object.species_string.toLowerCase() === procedureOptions.species.toLowerCase() : procedure)
        .filter(procedure => procedureOptions.status ? procedure.status === procedureOptions.status : procedure)
        .filter(procedure => procedureOptions.procedure ? procedure.name === procedureOptions.procedure : procedure)
        .filter(procedure => procedureOptions.ordered_start ? (procedureOptions.ordered_start <= moment(procedure.open).format('YYYY-MM-DD')) : procedure)
        .filter(procedure => procedureOptions.ordered_end ? (procedureOptions.ordered_end >= moment(procedure.open).format('YYYY-MM-DD')) : procedure)
        .filter(procedure => procedureOptions.complete_start ? (procedureOptions.complete_start <= moment(procedure.complete).format('YYYY-MM-DD')) : procedure)
        .filter(procedure => procedureOptions.complete_end ? (procedureOptions.complete_end >= moment(procedure.complete).format('YYYY-MM-DD')) : procedure)
        .filter(procedure => procedureOptions.performer ? procedure.performer_object && procedure.performer_object.id === procedureOptions.performer : procedure)
        .filter(procedure => procedureOptions.shelter && procedureOptions.shelter !== 'Field' ? procedure.animal_object.shelter === procedureOptions.shelter : procedure)
        .filter(procedure => procedureOptions.shelter === 'Field' ? procedure.animal_object.shelter === null : procedure)
      setProcedures(filtered_procedures);
      setNumPages(Math.ceil(filtered_procedures.length / ITEMS_PER_PAGE));
    }
  };

   function updateTooltip(search_tab) {
    setTooltip(tooltipDict[search_tab]);
  }

  const handleClear = () => {
    if (vetObject === 'vet_requests') {
      speciesRef.current.clearValue();
      statusRef.current.clearValue();
      priorityRef.current.clearValue();
      if (openStartRef.current) {
        openStartRef.current.flatpickr.clear();
      }
      if (openEndRef.current) {
        openEndRef.current.flatpickr.clear();
      }
      openerRef.current.clearValue();
      shelterRef.current.clearValue();
      setOptions({species:'', status:null, priority:null, open_start:null, open_end:null, assignee:null, shelter:''});
      setVetRequests(data.vet_requests);
    }
    else if (vetObject === 'treatments') {
      treatmentRef.current.clearValue();
      treatmentSpeciesRef.current.clearValue();
      treatmentStatusRef.current.clearValue();
      treatmentShelterRef.current.clearValue();
      notAdministeredRef.current.clearValue();
      administratorRef.current.clearValue();
      if (scheduledStartRef.current) {
        scheduledStartRef.current.flatpickr.clear();
      }
      if (scheduledEndRef.current) {
        scheduledEndRef.current.flatpickr.clear();
      }
      if (administeredStartRef.current) {
        administeredStartRef.current.flatpickr.clear();
      }
      if (administeredEndRef.current) {
        administeredEndRef.current.flatpickr.clear();
      }
      setTreatmentOptions({species:'', status:null, not_administered:null, treatment:null, scheduled_start:null, scheduled_end:null, administered_start:null, administered_end:null, assignee:null, shelter:''});
      setTreatments(data.treatments);
    }
    else if (vetObject === 'diagnostics') {
      diagnosticRef.current.clearValue();
      diagnosticSpeciesRef.current.clearValue();
      diagnosticStatusRef.current.clearValue();
      diagnosticShelterRef.current.clearValue();
      if (diagnosticOrderedStartRef.current) {
        diagnosticOrderedStartRef.current.flatpickr.clear();
      }
      if (diagnosticOrderedEndRef.current) {
        diagnosticOrderedEndRef.current.flatpickr.clear();
      }
      if (diagnosticCompleteStartRef.current) {
        diagnosticCompleteStartRef.current.flatpickr.clear();
      }
      if (diagnosticCompleteEndRef.current) {
        diagnosticCompleteEndRef.current.flatpickr.clear();
      }
      setDiagnosticOptions({species:'', status:null, diagnostic:null, ordered_start:null, ordered_end:null, complete_start:null, complete_end:null, shelter:''});
      setDiagnostics(data.diagnostics);
    }
    else if (vetObject === 'procedures') {
      procedureRef.current.clearValue();
      procedureSpeciesRef.current.clearValue();
      procedureStatusRef.current.clearValue();
      procedureShelterRef.current.clearValue();
      if (procedureOrderedStartRef.current) {
        procedureOrderedStartRef.current.flatpickr.clear();
      }
      if (procedureOrderedEndRef.current) {
        procedureOrderedEndRef.current.flatpickr.clear();
      }
      if (procedureCompleteStartRef.current) {
        procedureCompleteStartRef.current.flatpickr.clear();
      }
      if (procedureCompleteEndRef.current) {
        procedureCompleteEndRef.current.flatpickr.clear();
      }
      setProcedureOptions({species:'', status:null, procedure:null, ordered_start:null, ordered_end:null, complete_start:null, complete_end:null, performer:null, shelter:''});
      setProcedures(data.procedures);
    }
  };

  const customStyles = {
    // For the select it self, not the options of the select
    control: (styles, { isDisabled}) => {
      return {
        ...styles,
        color: '#FFF',
        cursor: isDisabled ? 'not-allowed' : 'default',
        backgroundColor: isDisabled ? '#DFDDDD' : 'white',
        height: 37,
        minHeight: 37,
        marginBottom: "15px"
      }
    },
    option: provided => ({
      ...provided,
      color: 'black'
    }),
  };

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchSpecies = () => {
      setSpeciesChoices([]);
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let species_options = [];
          response.data.forEach(result => {
            // Build species option list.
            species_options.push({value: result.name, label: result.name});
          });
          setSpeciesChoices(species_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: []});
          setShowSystemError(true);
        }
      });
    };
    fetchSpecies();

    const fetchTreatments = () => {
      setTreatmentChoices([]);
      // Fetch Treatment data.
      axios.get('/vet/api/treatment/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let treatment_options = [];
          response.data.forEach(result => {
            // Build treatment option list.
            treatment_options.push({value: result.description, label: result.description});
          });
          setTreatmentChoices(treatment_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setTreatmentChoices([]);
          setShowSystemError(true);
        }
      });
    };
    fetchTreatments();

    const fetchDiagnostics = () => {
      setTreatmentChoices([]);
      // Fetch Treatment data.
      axios.get('/vet/api/diagnostics/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let diagnostic_options = [];
          response.data.forEach(result => {
            // Build diagnostic option list.
            diagnostic_options.push({value: result.name, label: result.name});
          });
          setDiagnosticChoices(diagnostic_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setDiagnosticChoices([]);
          setShowSystemError(true);
        }
      });
    };
    fetchDiagnostics();

    const fetchProcedures = () => {
      setProcedureChoices([]);
      // Fetch Procedure data.
      axios.get('/vet/api/procedures/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let procedure_options = [];
          response.data.forEach(result => {
            // Build procedure option list.
            procedure_options.push({value: result.name, label: result.name});
          });
          setProcedureChoices(procedure_options);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setProcedureChoices([]);
          setShowSystemError(true);
        }
      });
    };
    fetchProcedures();

    const fetchShelters = () => {
      setShelters({options: [], isFetching: true});
      // Fetch Shelter data.
      axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let shelter_options = [];
          response.data.forEach(shelter => {
            // Build shelter option list.
            shelter_options.push({value: shelter.id, label: shelter.name});
          });
          shelter_options.push({value: 'Field', label: 'Field'});
          setShelters({options: shelter_options, isFetching:false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    fetchShelters();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [incident]);

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    setData(prevState => ({ ...prevState, "isFetching":true }));

    const fetchVetRequests = async () => {
      // Fetch VetRequest data.
      await axios.get('/vet/api/vetrequest/?search=' + searchTerm + '&incident=' + state.incident.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.filter(vr => vr.status === options.status).length / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "vet_requests":response.data, isFetching:false }));
          handleApplyFilters(response.data);

          // Build opener option list.
          let openers = [];
          response.data.forEach(vet_request => {
            if (openers.filter(opener => opener.value === vet_request.requested_by_object.id).length === 0) {
              openers.push({'value':vet_request.requested_by_object.id, 'label':vet_request.requested_by_object.first_name + ' ' + vet_request.requested_by_object.last_name});
            }
          });
          setAssignees({options: openers, isFetching:false});

          // highlight search terms
          markInstances(searchTerm);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setData({vet_requests: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    if (vetObject === 'vet_requests') {
      fetchVetRequests();
    }

    const fetchTreatments = () => {
      // Fetch TreatmentRequest data.
      axios.get('/vet/api/treatmentrequest/?search=' + searchTerm + '&incident=' + state.incident.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.filter(treatment => treatment.status === treatmentOptions.status).length / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "treatments":response.data, isFetching:false }));
          handleApplyFilters(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    if (vetObject === 'treatments') {
      fetchTreatments();
    }

    const fetchDiagnosticResult = async () => {
      // Fetch diagnostic result data.
      await axios.get('/vet/api/diagnosticresults/?search=' + searchTerm + '&incident=' + state.incident.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.filter(diagnostic => diagnostic.status === diagnosticOptions.status).length / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "diagnostics":response.data, isFetching:false }));
          handleApplyFilters(response.data);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };

    if (vetObject === 'diagnostics') {
      fetchDiagnosticResult();
    }

    const fetchProcedureResult = async () => {
      // Fetch procedure result data.
      await axios.get('/vet/api/procedureresults/?search=' + searchTerm + '&incident=' + state.incident.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setNumPages(Math.ceil(response.data.filter(procedure => procedure.status === procedureOptions.status).length / ITEMS_PER_PAGE));
          setData(prevState => ({ ...prevState, "procedures":response.data, isFetching:false }));
          handleApplyFilters(response.data);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };

    if (vetObject === 'procedures') {
      fetchProcedureResult();
    }

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [searchTerm, incident, vetObject]);

  // Hook handling option changes.
  useEffect(() => {
    const handleDisabled = () => {
      setIsDisabled(!(options.species || options.status || options.priority || options.open_start || options.open_end || options.opener || options.shelter));
      setTreatmentIsDisabled(!(treatmentOptions.species || treatmentOptions.status || treatmentOptions.treatment || treatmentOptions.scheduled_start || treatmentOptions.scheduled_end || treatmentOptions.administered_start || treatmentOptions.administered_end || treatmentOptions.assignee || (treatmentOptions.not_administered === true || treatmentOptions.not_administered === false) || treatmentOptions.shelter));
      setDiagnosticIsDisabled(!(diagnosticOptions.species || diagnosticOptions.status || diagnosticOptions.diagnostic || diagnosticOptions.ordered_start || diagnosticOptions.complete_start || diagnosticOptions.ordered_end || diagnosticOptions.complete_end || diagnosticOptions.shelter));
      setProcedureIsDisabled(!(procedureOptions.species || procedureOptions.status || procedureOptions.procedure || procedureOptions.ordered_start || procedureOptions.complete_start || procedureOptions.ordered_end || procedureOptions.complete_end || treatmentOptions.performer || procedureOptions.shelter));
    };

    handleDisabled();
  }, [options, treatmentOptions, diagnosticOptions, procedureOptions]);

  return (
    <div className="ms-2 me-2">
      <Header>Search Veterinary Tasks</Header>
      <Form onSubmit={handleSubmit}>
        <InputGroup className="mb-1">
          <FormControl
            type="text"
            placeholder="Search"
            name="searchTerm"
            onChange={handleChange}
            ref={tempSearchTerm}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit(e);
              }
            }}
            style={{height:"38px"}}
          />
          <Button variant="outline-light" type="submit" style={{height:"38px", borderRadius:"0 5px 5px 0", color:"white"}}>Search
            <OverlayTrigger
              key={"search-information"}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-search-information`}>
                  Searchable fields: {tooltip}.
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} className="ms-1 fa-move-up" size="sm" inverse />
            </OverlayTrigger>
          </Button>
          <Button variant="outline-light" className="ms-1 rounded" onClick={handleShowFilters} style={{height:"38px", color:"white"}}>Advanced {showFilters ? <FontAwesomeIcon icon={faChevronDoubleUp} className="fa-move-up" size="sm" /> : <FontAwesomeIcon icon={faChevronDoubleDown} className="fa-move-up" size="sm" />}</Button>
          <Col className="ps-2" style={{maxWidth:"220px"}}>
            <Select
              id="typeDropdown"
              name="vetType"
              type="text"
              options={[{value:'vet_requests', label:'Veterinary Requests'}, {value:'treatments', label:'Treatments'}, {value:'diagnostics', label:'Diagnostics'}, {value:'procedures', label:'Procedures'}]}
              styles={customStyles}
              isClearable={false}
              onChange={(instance) => {
                setVetObject(instance.value);
                updateTooltip(instance.value);
                handleClear();
              }}
              defaultValue={{value:tab, label:labelLookup[tab]}}
            />
          </Col>
        </InputGroup>
        {vetObject === 'vet_requests' ? <Collapse in={showFilters} className="mb-3">
          <div>
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              <Row className="gx-2" style={{marginBottom:"-5px"}}>
                <Col xs={"4"}>
                  <Select
                    id="statusDropdown"
                    name="Status"
                    type="text"
                    placeholder="Select Status"
                    options={statusChoices}
                    styles={customStyles}
                    isClearable={true}
                    ref={statusRef}
                    onChange={(instance) => {
                      setOptions({...options, status: instance ? instance.value : null});
                    }}
                    value={options.status ? {value:options.status, label:options.status} : null}
                  />
                </Col>
                <Col xs="4" className="" style={{textTransform:"capitalize"}}>
                  <Select
                    id="speciesDropdown"
                    name="species"
                    type="text"
                    placeholder="Select Species"
                    options={speciesChoices}
                    styles={customStyles}
                    isClearable={true}
                    ref={speciesRef}
                    onChange={(instance) => {
                      setOptions({...options, species: instance ? instance.value : null});
                    }}
                    value={options.species ? {value:options.species, label:options.species} : null}
                  />
                </Col>
                <Col className="flex-grow-1" xs="3">
                  <Button className="btn btn-primary" style={{maxHeight:"36px", width:"100%"}} onClick={(e) => {handleApplyFilters(data.vet_requests)}} disabled={isDisabled}>Apply</Button>
                </Col>
              </Row>
              <Row className="gx-2" style={{marginBottom:"-5px"}}>
                <Col xs={4}>
                  <Select
                    id="priorityDropdown"
                    name="priority"
                    type="text"
                    placeholder="Select Priority"
                    options={priorityChoices}
                    styles={customStyles}
                    isClearable={true}
                    ref={priorityRef}
                    onChange={(instance) => {
                      setOptions({...options, priority: instance ? instance.value : null});
                    }}
                    value={options.priority ? {value:options.priority, label:priorityText[options.priority]} : null}
                  />
                </Col>
                <Col xs={4}>
                  <Select
                    id="shelterDropdown"
                    name="shelter"
                    type="text"
                    placeholder="Select Shelter"
                    options={shelters.options}
                    styles={customStyles}
                    isClearable={true}
                    ref={shelterRef}
                    onChange={(instance) => {
                      setOptions({...options, shelter: instance ? instance.value : ''})
                    }}
                    value={options.shelter ? shelters.options.filter(shelter => shelter.value === options.shelter)[0] : null}
                  />
                </Col>
                <Col className="flex-grow-1" xs="2">
                  <Button variant="outline-light" style={{maxHeight:"36px", width:"100%"}} onClick={handleClear}>Clear</Button>
                </Col>
              </Row>
              <Row className="gx-2" style={{marginBottom:"-5px"}}>
                <Col xs={4}>
                  <Select
                    id="assigneeDropdown"
                    name="assignee"
                    type="text"
                    placeholder="Select Opener"
                    options={assignees.options}
                    styles={customStyles}
                    isClearable={true}
                    ref={openerRef}
                    onChange={(instance) => {
                      setOptions({...options, opener: instance ? instance.value : null});
                    }}
                    value={options.opener ? assignees.options.filter(assignee => assignee.value === options.opener)[0] : null}
                  />
                </Col>
              </Row>
              <Row className="gx-2" style={{marginBottom:"0px", maxHeight:"37px"}}>
                <Col xs={4} style={{textTransform:"capitalize"}}>
                  <DateRangePicker
                    name={`open_start`}
                    id={`open_start`}
                    placeholder={"Filter by Scheduled Start Date"}
                    style={{height:"36px"}}
                    ref={openStartRef}
                    data-enable-time={true}
                    clearable="true"
                    value={options.open_start || null}
                    onChange={(dateRange) => {
                      setOptions({...options, open_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs={4} style={{textTransform:"capitalize"}}>
                  <DateRangePicker
                    name={`open_end`}
                    id={`open_end`}
                    mode="single"
                    placeholder={"Filter by Scheduled End Date"}
                    style={{height:"36px"}}
                    ref={openEndRef}
                    data-enable-time={true}
                    clearable="true"
                    hour={23}
                    minute={59}
                    value={options.open_end || null}
                    onChange={(dateRange) => {
                      setOptions({...options, open_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
          </div>
        </Collapse>
        : vetObject === 'treatments' ? <Collapse in={showFilters} className="mb-3">
        <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={4}>
                <Select
                  id="treatmentStatusDropdown"
                  name="treatmentStatus"
                  type="text"
                  placeholder="Select Status"
                  options={treatmentStatusChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={treatmentStatusRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, status: instance ? instance.value : null});
                  }}
                  value={treatmentOptions.status ? {value:treatmentOptions.status, label:treatmentOptions.status} : null}
                />
              </Col>
              <Col xs={4} style={{textTransform:"capitalize"}}>
                <Select
                  id="treatmentSpeciesDropdown"
                  name="treatmentSpecies"
                  type="text"
                  placeholder="Select Species"
                  options={speciesChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={treatmentSpeciesRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, species: instance ? instance.value : null});
                  }}
                  value={treatmentOptions.species ? {value:treatmentOptions.species, label:treatmentOptions.species} : null}
                />
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button className="btn btn-primary" style={{maxHeight:"36px", width:"100%"}} onClick={(e) => {handleApplyFilters(data.treatments)}} disabled={treatmentIsDisabled}>Apply</Button>
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={4}>
                <Select
                  id="treatmentDropdown"
                  name="treatment"
                  type="text"
                  placeholder="Select Treatment"
                  options={treatmentChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={treatmentRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, treatment: instance ? instance.value : ''})
                  }}
                  value={treatmentOptions.treatment ? {value:treatmentOptions.treatment, label:treatmentOptions.treatment} : null}
                />
              </Col>
              <Col xs={4}>
                <Select
                  id="treatmentShelterDropdown"
                  name="treatmentShelter"
                  type="text"
                  placeholder="Select Shelter"
                  options={shelters.options}
                  styles={customStyles}
                  isClearable={true}
                  ref={treatmentShelterRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, shelter: instance ? instance.value : ''})
                  }}
                  value={treatmentOptions.shelter ? shelters.options.filter(shelter => shelter.value === treatmentOptions.shelter)[0] : null}
                />
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button variant="outline-light" style={{maxHeight:"36px", width:"100%"}} onClick={handleClear}>Clear</Button>
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={4}>
                <Select
                  id="administratorDropdown"
                  name="administrator"
                  type="text"
                  placeholder="Select Administrator"
                  options={assignees.options}
                  styles={customStyles}
                  isClearable={true}
                  ref={administratorRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, assignee: instance ? instance.value : null});
                  }}
                  value={treatmentOptions.assignee ? assignees.options.filter(assignee => assignee.value === treatmentOptions.assignee)[0] : null}
                />
              </Col>
              <Col xs={4}>
                <Select
                  id="notAdministeredDropdown"
                  name="notAdministered"
                  type="text"
                  placeholder="Select Not Administered"
                  options={[{value:true, label:"True"},{value:false, label:'False'}]}
                  styles={customStyles}
                  isClearable={true}
                  ref={notAdministeredRef}
                  onChange={(instance) => {
                    setTreatmentOptions({...treatmentOptions, not_administered : instance ? instance.value : null});
                  }}
                  value={treatmentOptions.not_administered === true || treatmentOptions.not_administered === false ? {value:treatmentOptions.not_administered, label:treatmentOptions.not_administered === true ? 'True' : 'False'} : null}
                />
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={4}>
                <DateRangePicker
                  name={`treatment_scheduled_start`}
                  id={`treatment_scheduled_start`}
                  mode="single"
                  placeholder={"Filter by Scheduled Start Date"}
                  style={{height:"36px"}}
                  ref={scheduledEndRef}
                  clearable="true"
                  value={treatmentOptions.scheduled_start || null}
                  onChange={(dateRange) => {
                    setTreatmentOptions({...options, scheduled_start: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
              <Col xs={4}>
                <DateRangePicker
                  name={`treatment_scheduled_end`}
                  id={`treatment_scheduled_end`}
                  mode="single"
                  placeholder={"Filter by Scheduled End Date"}
                  style={{height:"36px"}}
                  ref={scheduledEndRef}
                  clearable="true"
                  value={treatmentOptions.scheduled_end || null}
                  onChange={(dateRange) => {
                    setTreatmentOptions({...options, scheduled_end: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
            </Row>
            <Row className="gx-2" style={{marginTop:"14px"}}>
              <Col xs={4}>
                <DateRangePicker
                  name={`treatment_administered_start`}
                  id={`treatment_administered_start`}
                  mode="single"
                  placeholder={"Filter by Administered Start Date"}
                  style={{height:"36px"}}
                  ref={administeredStartRef}
                  clearable="true"
                  value={treatmentOptions.administered_start || null}
                  onChange={(dateRange) => {
                    setTreatmentOptions({...options, administered_start: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
              <Col xs={4}>
                <DateRangePicker
                  name={`treatment_administered_end`}
                  id={`treatment_administered_end`}
                  mode="single"
                  placeholder={"Filter by Administered End Date"}
                  style={{height:"36px"}}
                  ref={administeredEndRef}
                  clearable="true"
                  value={treatmentOptions.administered_end || null}
                  onChange={(dateRange) => {
                    setTreatmentOptions({...options, administered_end: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse>
      : vetObject === 'diagnostics' ?
      <Collapse in={showFilters} className="mb-3">
      <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={4}>
                <Select
                  id="diagnosticStatusDropdown"
                  name="diagnosticStatus"
                  type="text"
                  placeholder="Select Status"
                  options={orderStatusChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={diagnosticStatusRef}
                  onChange={(instance) => {
                    setDiagnosticOptions({...diagnosticOptions, status: instance ? instance.value : null});
                  }}
                  value={diagnosticOptions.status ? {value:diagnosticOptions.status, label:diagnosticOptions.status} : null}
                />
              </Col>
              <Col xs={4} style={{textTransform:"capitalize"}}>
                    <Select
                      id="diagnosticSpeciesDropdown"
                      name="diagnosticSpecies"
                      type="text"
                      placeholder="Select Species"
                      options={speciesChoices}
                      styles={customStyles}
                      isClearable={true}
                      ref={diagnosticSpeciesRef}
                      onChange={(instance) => {
                        setDiagnosticOptions({...diagnosticOptions, species: instance ? instance.value : null});
                      }}
                      value={diagnosticOptions.species ? {value:diagnosticOptions.species, label:diagnosticOptions.species} : null}
                    />
                </Col>
                <Col className="flex-grow-1" xs="3">
                  <Button className="btn btn-primary" style={{maxHeight:"36px", width:"100%"}} onClick={(e) => {handleApplyFilters(data.diagnostics)}} disabled={diagnosticIsDisabled}>Apply</Button>
                </Col>
              </Row>
              <Row className="gx-2" style={{marginBottom:"-5px"}}>
                <Col xs={4}>
                  <Select
                    id="diagnosticDropdown"
                    name="diagnostic"
                    type="text"
                    placeholder="Select Diagnostic"
                    options={diagnosticChoices}
                    styles={customStyles}
                    isClearable={true}
                    ref={diagnosticRef}
                    onChange={(instance) => {
                      setDiagnosticOptions({...diagnosticOptions, diagnostic: instance ? instance.value : ''})
                    }}
                    value={diagnosticOptions.diagnostic ? {value:diagnosticOptions.diagnostic, label:diagnosticOptions.diagnostic} : null}
                  />
                </Col>
                <Col xs={4}>
                  <Select
                    id="diagnosticShelterDropdown"
                    name="diagnosticShelter"
                    type="text"
                    placeholder="Select Shelter"
                    options={shelters.options}
                    styles={customStyles}
                    isClearable={true}
                    ref={diagnosticShelterRef}
                    onChange={(instance) => {
                      setDiagnosticOptions({...diagnosticOptions, shelter: instance ? instance.value : ''})
                    }}
                    value={diagnosticOptions.shelter ? shelters.options.filter(shelter => shelter.value === diagnosticOptions.shelter)[0] : null}
                  />
                </Col>
                <Col className="flex-grow-1" xs="3">
                  <Button variant="outline-light" style={{maxHeight:"36px", width:"100%"}} onClick={handleClear}>Clear</Button>
                </Col>
              </Row>
              <Row className="gx-2" style={{marginBottom:"-5px"}}>
                <Col xs={4}>
                  <DateRangePicker
                    name={`diagnostic_ordered_start`}
                    id={`diagnostic_ordered_start`}
                    mode="single"
                    placeholder={"Filter by Scheduled Start Date"}
                    style={{height:"36px"}}
                    ref={diagnosticOrderedStartRef}
                    clearable="true"
                    value={diagnosticOptions.ordered_start || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...options, ordered_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs={4}>
                  <DateRangePicker
                    name={`diagnostic_ordered_end`}
                    id={`diagnostic_ordered_end`}
                    mode="single"
                    placeholder={"Filter by Scheduled End Date"}
                    style={{height:"36px"}}
                    ref={diagnosticOrderedEndRef}
                    clearable="true"
                    value={diagnosticOptions.ordered_end || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...options, ordered_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
              </Row>
              <Row className="gx-2" style={{marginTop:"14px"}}>
                <Col xs={4}>
                  <DateRangePicker
                    name={`diagnostic_complete_start`}
                    id={`diagnostic_complete_start`}
                    mode="single"
                    placeholder={"Filter by Completed Start Date"}
                    style={{height:"36px"}}
                    ref={diagnosticCompleteStartRef}
                    clearable="true"
                    value={diagnosticOptions.complete_start || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...options, complete_start: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
                <Col xs={4}>
                  <DateRangePicker
                    name={`diagnostic_complete_end`}
                    id={`diagnostic_complete_end`}
                    mode="single"
                    placeholder={"Filter by Completed End Date"}
                    style={{height:"36px"}}
                    ref={diagnosticCompleteEndRef}
                    clearable="true"
                    value={diagnosticOptions.complete_end || null}
                    onChange={(dateRange) => {
                      setDiagnosticOptions({...options, complete_end: dateRange.length ? dateRange[0] : null});
                    }}
                  />
                </Col>
              </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse> : vetObject === 'procedures' ?
      <Collapse in={showFilters} className="mb-3">
      <div>
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={"4"}>
                <Select
                  id="statusDropdown"
                  name="procedureStatus"
                  type="text"
                  placeholder="Select Status"
                  options={orderStatusChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={procedureStatusRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, status: instance ? instance.value : null});
                  }}
                  value={procedureOptions.status ? {value:procedureOptions.status, label:procedureOptions.status} : null}
                />
              </Col>
              <Col xs={"4"} style={{textTransform:"capitalize"}}>
                <Select
                  id="speciesDropdown"
                  name="species"
                  type="text"
                  placeholder="Select Species"
                  options={speciesChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={procedureSpeciesRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, species: instance ? instance.value : null});
                  }}
                  value={procedureOptions.species ? {value:procedureOptions.species, label:procedureOptions.species} : null}
                />
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button className="btn btn-primary" style={{maxHeight:"36px", width:"100%"}} onClick={(e) => {handleApplyFilters(data.procedures)}} disabled={procedureIsDisabled}>Apply</Button>
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={"4"}>
                <Select
                  id="procedureDropdown"
                  name="procedure"
                  type="text"
                  placeholder="Select Procedure"
                  options={procedureChoices}
                  styles={customStyles}
                  isClearable={true}
                  ref={procedureRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, procedure: instance ? instance.value : ''})
                  }}
                  value={procedureOptions.procedure ? {value:procedureOptions.procedure, label:procedureOptions.procedure} : null}
                />
              </Col>
              <Col xs={"4"}>
                <Select
                  id="shelterDropdown"
                  name="shelter"
                  type="text"
                  placeholder="Select Shelter"
                  options={shelters.options}
                  styles={customStyles}
                  isClearable={true}
                  ref={procedureShelterRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, shelter: instance ? instance.value : ''})
                  }}
                  value={procedureOptions.shelter ? shelters.options.filter(shelter => shelter.value === procedureOptions.shelter)[0] : null}
                />
              </Col>
              <Col className="flex-grow-1" xs="3">
                <Button variant="outline-light" style={{maxHeight:"36px", width:"100%"}} onClick={handleClear}>Clear</Button>
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={"4"}>
                <Select
                  id="performerDropdown"
                  name="performer"
                  type="text"
                  placeholder="Select Performer"
                  options={assignees.options}
                  styles={customStyles}
                  isClearable={true}
                  ref={performerRef}
                  onChange={(instance) => {
                    setProcedureOptions({...procedureOptions, performer: instance ? instance.value : null});
                  }}
                  value={procedureOptions.performer ? assignees.options.filter(assignee => assignee.value === procedureOptions.performer)[0] : null}
                />
              </Col>
            </Row>
            <Row className="gx-2" style={{marginBottom:"-5px"}}>
              <Col xs={"4"}>
                <DateRangePicker
                  name={`procedure_ordered_start`}
                  id={`procedure_ordered_start`}
                  mode="single"
                  placeholder={"Filter by Scheduled Start Date"}
                  style={{height:"36px"}}
                  ref={procedureOrderedStartRef}
                  clearable="true"
                  value={procedureOptions.ordered_start || null}
                  onChange={(dateRange) => {
                    setProcedureOptions({...options, ordered_start: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
              <Col xs={"4"}>
                <DateRangePicker
                  name={`procedure_ordered_end`}
                  id={`procedure_ordered_end`}
                  mode="single"
                  placeholder={"Filter by Scheduled End Date"}
                  style={{height:"36px"}}
                  ref={procedureOrderedEndRef}
                  clearable="true"
                  value={procedureOptions.ordered_end || null}
                  onChange={(dateRange) => {
                    setProcedureOptions({...options, ordered_end: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
            </Row>
            <Row className="gx-2" style={{marginTop:"14px"}}>
              <Col xs={"4"}>
                <DateRangePicker
                  name={`procedure_complete_start`}
                  id={`procedure_complete_start`}
                  mode="single"
                  placeholder={"Filter by Completed Start Date"}
                  style={{height:"36px"}}
                  ref={procedureCompleteStartRef}
                  clearable="true"
                  value={procedureOptions.complete_start || null}
                  onChange={(dateRange) => {
                    setProcedureOptions({...options, complete_start: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
              <Col xs={"4"}>
                <DateRangePicker
                  name={`procedure_complete_end`}
                  id={`procedure_complete_end`}
                  mode="single"
                  placeholder={"Filter by Completed End Date"}
                  style={{height:"36px"}}
                  ref={procedureCompleteEndRef}
                  clearable="true"
                  value={procedureOptions.complete_end || null}
                  onChange={(dateRange) => {
                    setProcedureOptions({...options, complete_end: dateRange.length ? dateRange[0] : null});
                  }}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
        </div>
      </Collapse> : ""}
      </Form>
      {vetObject === 'vet_requests' && vetRequests.map((vet_request, index) => (
      <Row key={vet_request.id_for_incident} className="ms-0 mb-3" hidden={page !== Math.ceil((index+1)/ITEMS_PER_PAGE)}>
        <Link href={"/" + organization + "/" + incident + "/vet/vetrequest/" + vet_request.id_for_incident} className="treatment-link ps-0" style={{textDecoration:"none", color:"white", width:"845px"}}>
          <Card className="border rounded treatment-hover-div" style={{height:"120px", width:"845px", whiteSpace:"nowrap", overflow:"hidden"}}>
            <div className="row no-gutters hover-div treatment-hover-div" style={{height:"120px", marginRight:"-2px"}}>
              <Row className="ms-0 me-0 w-100" style={{flexWrap:"nowrap"}}>
                <div className="border-end" style={{width:"120px"}}>
                  <FontAwesomeIcon icon={faUserDoctorMessage} size="5x" className="treatment-icon" style={{marginTop:"21px", marginLeft:"4px"}} transform={'grow-1'} inverse />
                </div>
                <Col style={{marginLeft:"-5px", marginRight:"-18px", paddingRight:"0px"}} className="hover-div">
                  <div className="border treatment-hover-div" style={{paddingTop:"5px", paddingBottom:"7px", paddingLeft:"10px", marginLeft:"-8px", marginTop: "-1px", fontSize:"18px", width:"100%", backgroundColor:"rgb(158 153 153)"}}>
                    VR#{vet_request.id_for_incident} - {priorityText[vet_request.priority]}
                    <span className="float-end">
                    {vet_request.status === 'Closed' ?
                      <OverlayTrigger
                        key={"complete-treatment-request"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-complete-treatment-request`}>
                            All treatment requests are completed.
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faCheckSquare} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                      </OverlayTrigger>
                      : vet_request.status === 'Canceled' ?
                      <OverlayTrigger
                        key={"not-administered-treatment-request"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-not-administered-treatment-request`}>
                            Treatment request was canceled.
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faSquareX} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                      </OverlayTrigger>
                      :
                      <OverlayTrigger
                        key={"awaiting-action-treatment-request"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-awaiting-action-treatment-request`}>
                            Treatment request is pending action.
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faSquareExclamation} size="3x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                      </OverlayTrigger>
                      }
                    </span>
                  </div>
                  <Row style={{marginTop:"6px"}}>
                    <Col xs={4}>
                      <b>Patient: </b>A#{vet_request.animal_object.id_for_incident}
                    </Col>
                    <Col xs={3}>
                      <b>Species:</b> <span  style={{textTransform:"capitalize"}}>{vet_request.animal_object.species_string}</span>
                    </Col>
                    <Col xs={5}>
                      <b>Name: </b>{vet_request.animal_object.name || "Unknown Name"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}>
                      <b>Scheduled: </b><Moment format="MMM DD YYYY, HH:mm">{vet_request.open}</Moment>
                    </Col>
                    <Col xs={3}>
                      <b>Opener: </b>{vet_request.requested_by_object.first_name} {vet_request.requested_by_object.last_name}
                    </Col>
                    <Col xs={5}>
                      <b>Location: </b>{vet_request.animal_object.shelter_object ? <span>{vet_request.animal_object.shelter_object.name} {vet_request.animal_object.room_name ? <span> - {vet_request.animal_object.room_name}</span> : ""}</span> : "Field"}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <b>Complaints: </b>{vet_request.complaints_text}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Card>
        </Link>
      </Row>
      ))}
      {vetObject === 'treatments' && treatments.map((treatment_request, index) => (
        <TreatmentCard key={treatment_request.id} incident={incident} organization={organization} treatment_request={treatment_request} animal_object={treatment_request.animal_object} />
      ))}
      {vetObject === 'diagnostics' && diagnostics.map((diagnostic, index) => (
        <DiagnosticCard key={diagnostic.id} incident={incident} organization={organization} diagnostic={diagnostic} animal_object={diagnostic.animal_object} />
      ))}
      {vetObject === 'procedures' && procedures.map((procedure, index) => (
        <ProcedureCard key={procedure.id} incident={incident} organization={organization} procedure={procedure} animal_object={procedure.animal_object} />
      ))}
      {data.isFetching ? <p>{'Fetching ' + (vetObject === 'vet_requests' ? 'veterinary requests' : vetObject === 'treatments' ? 'treatments' : vetObject === 'diagnostics' ? 'diagnostics' : 'procedures') + '...'}</p> : ""}
      {!data.isFetching && vetObject === 'vet_requests' && vetRequests.length === 0 ? <p>No veterinary requests found.</p> : ""}
      {!data.isFetching && vetObject === 'treatments' && treatments.length === 0 ? <p>No treatments found.</p> : ""}
      {!data.isFetching && vetObject === 'diagnostics' && diagnostics.length === 0 ? <p>No diagnostics found.</p> : ""}
      {!data.isFetching && vetObject === 'procedures' && procedures.length === 0 ? <p>No procedures found.</p> : ""}
      <Pagination className="custom-page-links" size="lg" onClick={(e) => {setFocus(parseInt(e.target.innerText));setPage(parseInt(e.target.innerText))}}>
        {[...Array(numPages).keys()].map(x =>
        <Pagination.Item key={x+1} active={x+1 === page}>
          {x+1}
        </Pagination.Item>)
        }
      </Pagination>
    </div>
  )
}

export default VetRequestSearch;
